export * from "./prim.blog-detail-head";
